<template>
    <div v-if="showModal" id="parcel_item_detail" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">택배건 상세정보 - {{ item._id }}</h3>
            </div>
            <div id="body" class="ui segment">
                <table class="ui definition compact table">
                <tbody>
                    <tr>
                        <td class="collapsing">판매처</td>
                        <td colspan="2">{{ item.seller }}</td>
                    </tr>
                    <tr>
                        <td class="collapsing">택배사</td>
                        <td colspan="2">
                            <select class="ui simple dropdown" v-model="item.company" @change="checkChanged" :disabled="item.isCanceled || isPartner || isCenter">
                                <option :value="''">없음</option>
                                <option :value="'롯데'">롯데</option>
                                <option :value="'대신'">대신</option>
                                <option :value="'로젠'">로젠</option>
                                <option :value="'일양'">일양</option>
                                <option :value="'한진'">한진</option>
                                <option :value="'대한'">대한</option>
                            </select>
                        </td>
                    </tr>
                    <tr :class="item.number != oldItem.number ? 'yellow' : ''">
                        <td class="collapsing">운송장번호</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="number" v-model="item.number" @change="checkChanged" :disabled="item.isCanceled">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="collapsing">주문날짜</td>
                        <td colspan="2">{{ item.orderedAt.format("yyyy-MM-dd(KS) hh:mm") }}</td>
                    </tr>
                    <tr>
                        <td class="collapsing">주문자</td>
                        <td colspan="2">{{ item.orderer }}</td>
                    </tr>
                    <tr>
                        <td class="collapsing">주문자 전화번호</td>
                        <td colspan="2">{{ item.ordererTel }}</td>
                    </tr>
                    <tr :class="item.receiver != oldItem.receiver ? 'yellow' : ''">
                        <td class="collapsing">수취인</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="text" v-model="item.receiver" @change="checkChanged">
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.receiverTel != oldItem.receiverTel ? 'yellow' : ''">
                        <td class="collapsing">수취인 전화번호</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="text" v-model="item.receiverTel" @change="checkChanged">
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.address != oldItem.address ? 'yellow' : ''">
                        <td class="collapsing">주소</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="text" v-model="item.address" @change="checkChanged">
                            </div>
                        </td>
                    </tr>
                    <tr :class="item.product != oldItem.product ? 'yellow' : ''">
                        <td class="collapsing">상품</td>
                        <td colspan="2">{{ item.product }}</td>
                    </tr>
                    <tr :class="item.count != oldItem.count ? 'yellow' : ''">
                        <td class="collapsing">수량</td>
                        <td colspan="2"> {{ item.count }} </td>
                    </tr>
                    <tr>
                        <td class="collapsing">고객요청사항</td>
                        <td colspan="2">{{ item.clientMemo }}</td>
                    </tr>
                    <tr v-if="oldItem.status == constant.STATUS_CANCEL" class="red">
                        <td class="collapsing">취소사유</td>
                        <td colspan="2">
                            <div class="ui fluid input">
                                <input type="text" v-model="item.comment" @change="checkChanged">
                            </div>
                        </td>
                    </tr>
                    <tr v-if="oldItem.status != constant.STATUS_CANCEL">
                        <td class="collapsing">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="item.isCanceled" @change="checkChanged">
                                <label>취소</label>
                            </div>
                        </td>
                        <td colspan="2">
                            <div :class="item.isCanceled ? 'ui fluid input' : 'ui disabled fluid input'">
                                <input type="text" v-model="item.comment" placeholder="취소사유를 입력하세요">
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui text menu">
                    <div class="right menu">
                        <div class="item" v-if="isHeader && oldItem.isCanceled && item.isCanceled && oldItem.status != constant.STATUS_CANCEL">
                            <div class="ui orange button" @click="cancelItem">취소확정</div>
                        </div>
                        <div class="item" v-if="isChanged && oldItem.status != constant.STATUS_CANCEL">
                            <div class="ui orange button" @click="applyModified">저장</div>
                        </div>
                        <div class="item">
                            <div class="ui button" @click="close">닫기</div>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const moment = require("moment");

export default {
    data: function() {
        return { showModal: 0, oldItem: 0, item: 0, isChanged: 0, onChange: 0, }
    },
    created: function() {
        this.showModal = false;
        this.oldItem = this.item = this.onChange = 0;
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
        this.$event.set("parcelItemDetail_open", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("parcelItemDetail_open");
    },
    methods: {
        open(_itemId, onChange) {
            this.$event.call("openLoading");
            this.$api.getParcelItem(_itemId, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else if (resData.item) {
                    this.showModal = true;
                    this.oldItem = resData.item;
                    this.item = JSON.parse(JSON.stringify(resData.item));
                    this.item.orderedAt = moment(resData.item.orderedAt).toDate();
                    this.onChange = onChange;
                    this.checkChanged();
                }
            });
        },
        close() {
            this.showModal = false;
        },
        checkChanged() {
            this.isChanged = false;
            if (this.item.number != this.oldItem.number) this.isChanged = true;
            if (this.item.receiver != this.oldItem.receiver) this.isChanged = true;
            if (this.item.receiverTel != this.oldItem.receiverTel) this.isChanged = true;
            if (this.item.address != this.oldItem.address) this.isChanged = true;
            if (this.item.isCanceled != this.oldItem.isCanceled) this.isChanged = true;
            if (this.item.comment != this.oldItem.comment) this.isChanged = true;
            if (this.item.company != this.oldItem.company) this.isChanged = true;
            this.$forceUpdate();
        },
        applyModified() {
            this.$api.modifyParcelItem(this.item, (resData) => {
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    if (this.onChange) this.onChange();
                    this.close();
                }
            })
        },
        cancelItem() {
            this.$event.call("openLoading");
            this.$api.cancelParcelItem(this.item, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    if (this.onChange) this.onChange();
                    this.close();
                }
            });
        },
    },
    computed: {
        centers: function() { return this.$store.getters.centers; },
        workers: function() { return this.$store.getters.workers; },
        products: function() { return this.$store.getters.products; },
        isHeader: function() { return this.$store.getters.isHeader; },
        isCenter: function() { return this.$store.getters.isCenter; },
        isPartner: function() { return this.$store.getters.isPartner; },
        constant: function() { return this.$store.getters.constant; },
    },
}
</script>

<style>

#parcel_item_detail {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#parcel_item_detail .ui.column.segments {
    max-width: 600px;
}

#parcel_item_detail #header {
    padding: 20px 30px;
}

#parcel_item_detail #body {
    padding: 0;
    font-size: 13px;
}

#parcel_item_detail #body .table {
    padding: 30px;
}

#parcel_item_detail #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#parcel_item_detail #footer .ui.text.menu {
    margin: 0;
}

#parcel_item_detail .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/ParcelItemModal_Detail.vue